import { useI18n } from '../i18n';
import { outcomeFor, revealPair, type MatchMachineState } from '../match/machine';
import { ACTION_GLYPH, actionLabelKey } from './ChoiceButtons';

/**
 * 揭曉。只有 `state.lastResolved` 非 null（也就是收到 round_resolved）時才會渲染，
 * 由 `revealPair()` 在型別上保證：拿不到 lastResolved 就拿不到對手那一手。
 */
export function RevealPanel({ state }: { state: MatchMachineState }) {
  const { t } = useI18n();
  const pair = revealPair(state);
  if (!pair || !state.lastResolved) return null;

  const outcome = outcomeFor(state.mySeat, state.lastResolved.winner);
  const verdictKey = outcome === 'win' ? 'match.result.win' : outcome === 'lose' ? 'match.result.lose' : 'match.result.draw';

  return (
    <section className="reveal" aria-live="polite">
      <div className="reveal__hand">
        <span className="reveal__glyph" aria-hidden="true">
          {pair.mine ? (ACTION_GLYPH[pair.mine] ?? '?') : '?'}
        </span>
        <span className="faint">{t('match.yourPick')}</span>
        <strong>{pair.mine ? t(actionLabelKey(pair.mine)) : '—'}</strong>
      </div>

      <p className={`reveal__verdict reveal__verdict--${outcome}`}>{t(verdictKey)}</p>

      <div className="reveal__hand reveal__hand--theirs">
        <span className="reveal__glyph" aria-hidden="true">
          {pair.theirs ? (ACTION_GLYPH[pair.theirs] ?? '?') : '?'}
        </span>
        <span className="faint">{t('match.opponentPick')}</span>
        <strong>{pair.theirs ? t(actionLabelKey(pair.theirs)) : '—'}</strong>
      </div>
    </section>
  );
}
